import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {validateValue} from '../utils';

const WindowContext = !window.__dashprivate_embedded_context
    ? null
    : window.__dashprivate_embedded_context.context;

class InnerConsumerContext extends Component {
    render() {
        const {path: _path, setProps, value, contextValue} = this.props;

        const newContextValue = validateValue(
            _path,
            contextValue,
            'ConsumerContext'
        );

        if (newContextValue !== value) {
            setTimeout(() => setProps({value: newContextValue}), 0);
        }
        return null;
    }
}

/**
 * ConsumerContext is an Dash Embedded component.
 * It takes a context `value`, and `path`, uses
 * it to share state between Dash Embedded Comonent.
 */
export default class ConsumerContext extends Component {
    render() {
        if (WindowContext === null) {
            return null;
        }
        return (
            <WindowContext.Consumer>
                {contextValue => (
                    <InnerConsumerContext {...{...this.props, contextValue}} />
                )}
            </WindowContext.Consumer>
        );
    }
}

ConsumerContext.defaultProps = {};

ConsumerContext.propTypes = {
    /**
     * The ID used to identify this component in Dash callbacks.
     */
    id: PropTypes.string,

    /**
     * The value shared between the dash and host app.
     */
    value: PropTypes.any,

    /**
     * The path for the key in the context object to be acessed.
     * Zero-length path is not valid.
     */
    path: PropTypes.oneOfType([
        PropTypes.arrayOf(
            PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        ),
        PropTypes.string,
        PropTypes.number,
    ]),

    /**
     * Dash-assigned callback that should be called to report property changes
     * to Dash, to make them available for callbacks.
     */
    setProps: PropTypes.func,

    /**
     * The context value for the Context.Consumer.
     */
    contextValue: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

InnerConsumerContext.propTypes = ConsumerContext.propTypes;
